var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"switcher",attrs:{"hide-details":"auto","rules":_vm.rules,"true-value":true,"false-value":false,"input-value":_vm.value,"value":_vm.value,"label":_vm.label},on:{"change":function($event){_vm.$emit('input', $event);
    _vm.$emit('change', $event);}}})}
var staticRenderFns = []

export { render, staticRenderFns }